import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import { useDispatch } from "react-redux";
import { Button } from "@mui/material";
import strings from "../i18n/language";
import React from "react";
import { updateSubscriptionAction } from "../redux/actions/subscription";
import { toast } from "react-toastify";

const SubscriptionArchive = ({ open, setOpen, subscription }) => {
  const dispatch = useDispatch();
  const isArchiving = !subscription?.archive;

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="alert-dialog-archive-title"
      aria-describedby="alert-dialog-archive-description"
    >
      <DialogTitle id="alert-dialog-archive-title">
        {isArchiving
          ? strings.TITLE_CONFIRM_ARCHIVE
          : strings.TITLE_CONFIRM_UNARCHIVE}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-archive-description">
          {isArchiving
            ? strings.MESSAGE_CONFIRM_ARCHIVE_SUBSCRIPTION
            : strings.MESSAGE_CONFIRM_UNARCHIVE_SUBSCRIPTION}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
        >
          {strings.BUTTON_CANCEL}
        </Button>
        <Button
          onClick={() => {
            dispatch(
              updateSubscriptionAction({
                id: subscription.id,
                archive: isArchiving,
              })
            )
              .then(() => {
                toast.success(
                  isArchiving
                    ? strings.MESSAGE_SUBSCRIPTION_ARCHIVED
                    : strings.MESSAGE_SUBSCRIPTION_UNARCHIVED
                );
              })
              .catch(() => {
                toast.error(strings.ERROR_ARCHIVE_SUBSCRIPTION);
              });
            setOpen(false);
          }}
        >
          {strings.BUTTON_CONFIRM}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionArchive;
